import { supabase } from '../lib/supabase';

export const searchService = {
  /**
   * Records a search event in the search_history table
   */
  async recordSearch({ searchTerm, category, resultsCount = 0, userId = null, sessionId = null }) {
    if (!searchTerm || searchTerm.trim() === '') return;

    try {
      const { error } = await supabase
        .from('search_history')
        .insert({
          search_term: searchTerm.trim(),
          category,
          results_count: resultsCount,
          user_id: userId,
          session_id: sessionId,
          source: category === 'mixed_catalog' ? 'catalog' : 'general'
        });

      if (error) {
        console.error('Failed to record search history:', error);
      }
    } catch (err) {
      console.error('Error in recordSearch:', err);
    }
  },

  /**
   * Fetches recent searches for a user or session
   */
  async getRecentSearches({ userId = null, sessionId = null, limit = 5 }) {
    try {
      let query = supabase
        .from('search_history')
        .select('search_term')
        .order('created_at', { ascending: false });

      if (userId) {
        query = query.eq('user_id', userId);
      } else if (sessionId) {
        query = query.eq('session_id', sessionId);
      } else {
        return [];
      }

      const { data, error } = await query.limit(limit * 2); // Get more and deduplicate
      
      if (error) throw error;

      // Deduplicate
      const terms = [...new Set(data.map(item => item.search_term))];
      return terms.slice(0, limit);
    } catch (err) {
      console.error('Error fetching recent searches:', err);
      return [];
    }
  },

  /**
   * Fetches trending searches (most frequent in the last 7 days)
   */
  async getTrendingSearches(limit = 10) {
    try {
      // Note: This ideally should be an RPC for performance if the table is large
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

      const { data, error } = await supabase
        .from('search_history')
        .select('search_term')
        .gte('created_at', sevenDaysAgo.toISOString());

      if (error) throw error;

      // Basic aggregation in memory (for small scale)
      const counts = data.reduce((acc, curr) => {
        const term = curr.search_term.toLowerCase();
        acc[term] = (acc[term] || 0) + 1;
        return acc;
      }, {});

      return Object.entries(counts)
        .sort(([, a], [, b]) => b - a)
        .slice(0, limit)
        .map(([term]) => term);
    } catch (err) {
      console.error('Error fetching trending searches:', err);
      return [];
    }
  }
};
